<template lang="html">

  <section class="pe_splash-screen pe_splash-screen-trivia">
    
    <div class="pe_lovatts-slider" v-if="!unAuthorised">
      <span style="vertical-align: middle; font-size: 0.9em; padding-right: 5px;">CRAFTED BY</span> <span style="vertical-align: middle;"><LovattsLogo /></span>
    </div>
    <div class="pe_lovatts-slider-finish" v-if="!unAuthorised"><heart /></div>
    <!--<SlideoutMenu />-->

    <div class="pe_content" v-if="!unAuthorised" >

        <header>
          
          <transition name="fade">
            <div class="pe_header-wrap" v-if="setFontLoaded">

              <div class="pe_logo">
                <svg id="pe_svg_logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 609 601">

                  <rect class="pe_trivia_cls-5" x="9.35" y="9.35" width="581.31" height="581.31" rx="26.49" ry="26.49"/>
                  <path class="pe_trivia_cls-3" d="m564.16,600H35.84c-19.76,0-35.84-16.08-35.84-35.83V35.84C0,16.08,16.08,0,35.84,0h528.32c19.76,0,35.84,16.08,35.84,35.84v528.33c0,19.76-16.08,35.83-35.84,35.83ZM35.84,18.69c-9.45,0-17.15,7.69-17.15,17.15v528.33c0,9.45,7.69,17.14,17.15,17.14h528.32c9.45,0,17.15-7.69,17.15-17.14V35.84c0-9.45-7.69-17.15-17.15-17.15H35.84Z"/>
                  <rect class="pe_trivia_cls-2" x="74.83" y="74.83" width="198.68" height="198.68" rx="26.49" ry="26.49"/>
                  <path class="pe_trivia_cls-3" d="m247.02,282.85H101.32c-19.76,0-35.83-16.08-35.83-35.83V101.32c0-19.76,16.08-35.84,35.83-35.84h145.7c19.76,0,35.83,16.08,35.83,35.84v145.7c0,19.76-16.08,35.83-35.83,35.83ZM101.32,84.17c-9.45,0-17.14,7.69-17.14,17.15v145.7c0,9.45,7.69,17.14,17.14,17.14h145.7c9.45,0,17.14-7.69,17.14-17.14V101.32c0-9.45-7.69-17.15-17.14-17.15H101.32Z"/>
                  <rect class="pe_trivia_cls-2" x="326.49" y="74.83" width="198.68" height="198.68" rx="26.49" ry="26.49"/>
                  <path class="pe_trivia_cls-3" d="m498.68,282.85h-145.7c-19.76,0-35.83-16.08-35.83-35.83V101.32c0-19.76,16.08-35.84,35.83-35.84h145.7c19.76,0,35.83,16.08,35.83,35.84v145.7c0,19.76-16.08,35.83-35.83,35.83Zm-145.7-198.68c-9.45,0-17.14,7.69-17.14,17.15v145.7c0,9.45,7.69,17.14,17.14,17.14h145.7c9.45,0,17.14-7.69,17.14-17.14V101.32c0-9.45-7.69-17.15-17.14-17.15h-145.7Z"/>
                  <rect class="pe_trivia_cls-2" x="74.83" y="326.49" width="198.68" height="198.68" rx="26.49" ry="26.49"/>
                  <path class="pe_trivia_cls-3" d="m247.02,534.52H101.32c-19.76,0-35.83-16.08-35.83-35.83v-145.7c0-19.76,16.08-35.83,35.83-35.83h145.7c19.76,0,35.83,16.08,35.83,35.83v145.7c0,19.76-16.08,35.83-35.83,35.83Zm-145.7-198.68c-9.45,0-17.14,7.69-17.14,17.14v145.7c0,9.45,7.69,17.14,17.14,17.14h145.7c9.45,0,17.14-7.69,17.14-17.14v-145.7c0-9.45-7.69-17.14-17.14-17.14H101.32Z"/>
                  <rect class="pe_trivia_cls-1" x="326.49" y="326.49" width="198.68" height="198.68" rx="26.49" ry="26.49"/>
                  <path class="pe_trivia_cls-3" d="m498.68,534.52h-145.7c-19.76,0-35.83-16.08-35.83-35.83v-145.7c0-19.76,16.08-35.83,35.83-35.83h145.7c19.76,0,35.83,16.08,35.83,35.83v145.7c0,19.76-16.08,35.83-35.83,35.83Zm-145.7-198.68c-9.45,0-17.14,7.69-17.14,17.14v145.7c0,9.45,7.69,17.14,17.14,17.14h145.7c9.45,0,17.14-7.69,17.14-17.14v-145.7c0-9.45-7.69-17.14-17.14-17.14h-145.7Z"/>
                  <path class="pe_trivia_cls-3" d="m191.6,204.61h-35.14l-5.63,16.63h-24.01l34.06-94.14h26.55l34.06,94.14h-24.28l-5.63-16.63Zm-5.9-17.71l-11.67-34.47-11.53,34.47h23.2Z"/>
                  <path class="pe_trivia_cls-3" d="m458.42,181.08c3.31,4.25,4.96,9.1,4.96,14.55,0,7.87-2.75,14.1-8.25,18.71-5.5,4.6-13.16,6.9-23,6.9h-43.85v-94.14h42.38c9.56,0,17.05,2.19,22.46,6.57,5.41,4.38,8.11,10.33,8.11,17.84,0,5.54-1.46,10.14-4.36,13.81-2.9,3.67-6.77,6.22-11.6,7.64,5.45,1.16,9.83,3.87,13.14,8.11Zm-47.2-15.89h15.02c3.76,0,6.64-.82,8.65-2.48s3.02-4.09,3.02-7.31-1-5.68-3.02-7.38c-2.01-1.69-4.9-2.55-8.65-2.55h-15.02v19.71Zm25.81,34.94c2.1-1.74,3.15-4.27,3.15-7.57s-1.1-5.9-3.29-7.78c-2.19-1.88-5.21-2.82-9.05-2.82h-16.63v20.79h16.9c3.84,0,6.81-.88,8.92-2.62Z"/>
                  <path class="pe_trivia_cls-3" d="m134.2,401.03c4.02-7.29,9.63-12.96,16.83-17.03,7.2-4.07,15.36-6.1,24.47-6.1,11.18,0,20.74,2.95,28.7,8.85,7.96,5.9,13.28,13.95,15.96,24.14h-25.22c-1.88-3.93-4.54-6.93-7.98-8.98-3.45-2.06-7.36-3.08-11.74-3.08-7.06,0-12.79,2.46-17.16,7.37-4.39,4.92-6.58,11.49-6.58,19.71s2.19,14.8,6.58,19.72c4.38,4.91,10.1,7.37,17.16,7.37,4.38,0,8.29-1.03,11.74-3.08,3.44-2.05,6.1-5.05,7.98-8.98h25.22c-2.68,10.19-8,18.22-15.96,24.07-7.96,5.86-17.52,8.78-28.7,8.78-9.12,0-17.28-2.03-24.47-6.1-7.2-4.07-12.81-9.72-16.83-16.97-4.02-7.24-6.03-15.51-6.03-24.81s2.01-17.59,6.03-24.87Z"/>
                  <path class="pe_trivia_cls-4" d="m425.83,490.9c-28.33-15.76-72.61-56.7-70.8-93.06,1.87-37.56,49.96-53.55,70.8-14.41,20.84-39.14,68.93-23.15,70.8,14.41,1.81,36.36-42.47,77.29-70.8,93.06Z"/>
                </svg>

              </div>

              <div class="pe_title">
                <h1>Ultimate Trivia</h1>
                
              </div>
            </div>

          </transition>

        </header>

      <div class="pe_category-grid">

        <button 
          v-for="category in categories"
          :class="['pe_btn pe_primary pe_play']"
          @click="onPlayBtnClick(category.id)"
        >
          <span>{{ category.title }}</span>
        </button>

      </div>

    </div>

    <div class="pe_unauth" v-if="unAuthorised">
              <div class="pe_logo-unauth">
                <svg id="pe_svg_logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 609 601">

                  <rect class="pe_trivia_cls-5" x="9.35" y="9.35" width="581.31" height="581.31" rx="26.49" ry="26.49"/>
                  <path class="pe_trivia_cls-3" d="m564.16,600H35.84c-19.76,0-35.84-16.08-35.84-35.83V35.84C0,16.08,16.08,0,35.84,0h528.32c19.76,0,35.84,16.08,35.84,35.84v528.33c0,19.76-16.08,35.83-35.84,35.83ZM35.84,18.69c-9.45,0-17.15,7.69-17.15,17.15v528.33c0,9.45,7.69,17.14,17.15,17.14h528.32c9.45,0,17.15-7.69,17.15-17.14V35.84c0-9.45-7.69-17.15-17.15-17.15H35.84Z"/>
                  <rect class="pe_trivia_cls-2" x="74.83" y="74.83" width="198.68" height="198.68" rx="26.49" ry="26.49"/>
                  <path class="pe_trivia_cls-3" d="m247.02,282.85H101.32c-19.76,0-35.83-16.08-35.83-35.83V101.32c0-19.76,16.08-35.84,35.83-35.84h145.7c19.76,0,35.83,16.08,35.83,35.84v145.7c0,19.76-16.08,35.83-35.83,35.83ZM101.32,84.17c-9.45,0-17.14,7.69-17.14,17.15v145.7c0,9.45,7.69,17.14,17.14,17.14h145.7c9.45,0,17.14-7.69,17.14-17.14V101.32c0-9.45-7.69-17.15-17.14-17.15H101.32Z"/>
                  <rect class="pe_trivia_cls-2" x="326.49" y="74.83" width="198.68" height="198.68" rx="26.49" ry="26.49"/>
                  <path class="pe_trivia_cls-3" d="m498.68,282.85h-145.7c-19.76,0-35.83-16.08-35.83-35.83V101.32c0-19.76,16.08-35.84,35.83-35.84h145.7c19.76,0,35.83,16.08,35.83,35.84v145.7c0,19.76-16.08,35.83-35.83,35.83Zm-145.7-198.68c-9.45,0-17.14,7.69-17.14,17.15v145.7c0,9.45,7.69,17.14,17.14,17.14h145.7c9.45,0,17.14-7.69,17.14-17.14V101.32c0-9.45-7.69-17.15-17.14-17.15h-145.7Z"/>
                  <rect class="pe_trivia_cls-2" x="74.83" y="326.49" width="198.68" height="198.68" rx="26.49" ry="26.49"/>
                  <path class="pe_trivia_cls-3" d="m247.02,534.52H101.32c-19.76,0-35.83-16.08-35.83-35.83v-145.7c0-19.76,16.08-35.83,35.83-35.83h145.7c19.76,0,35.83,16.08,35.83,35.83v145.7c0,19.76-16.08,35.83-35.83,35.83Zm-145.7-198.68c-9.45,0-17.14,7.69-17.14,17.14v145.7c0,9.45,7.69,17.14,17.14,17.14h145.7c9.45,0,17.14-7.69,17.14-17.14v-145.7c0-9.45-7.69-17.14-17.14-17.14H101.32Z"/>
                  <rect class="pe_trivia_cls-1" x="326.49" y="326.49" width="198.68" height="198.68" rx="26.49" ry="26.49"/>
                  <path class="pe_trivia_cls-3" d="m498.68,534.52h-145.7c-19.76,0-35.83-16.08-35.83-35.83v-145.7c0-19.76,16.08-35.83,35.83-35.83h145.7c19.76,0,35.83,16.08,35.83,35.83v145.7c0,19.76-16.08,35.83-35.83,35.83Zm-145.7-198.68c-9.45,0-17.14,7.69-17.14,17.14v145.7c0,9.45,7.69,17.14,17.14,17.14h145.7c9.45,0,17.14-7.69,17.14-17.14v-145.7c0-9.45-7.69-17.14-17.14-17.14h-145.7Z"/>
                  <path class="pe_trivia_cls-3" d="m191.6,204.61h-35.14l-5.63,16.63h-24.01l34.06-94.14h26.55l34.06,94.14h-24.28l-5.63-16.63Zm-5.9-17.71l-11.67-34.47-11.53,34.47h23.2Z"/>
                  <path class="pe_trivia_cls-3" d="m458.42,181.08c3.31,4.25,4.96,9.1,4.96,14.55,0,7.87-2.75,14.1-8.25,18.71-5.5,4.6-13.16,6.9-23,6.9h-43.85v-94.14h42.38c9.56,0,17.05,2.19,22.46,6.57,5.41,4.38,8.11,10.33,8.11,17.84,0,5.54-1.46,10.14-4.36,13.81-2.9,3.67-6.77,6.22-11.6,7.64,5.45,1.16,9.83,3.87,13.14,8.11Zm-47.2-15.89h15.02c3.76,0,6.64-.82,8.65-2.48s3.02-4.09,3.02-7.31-1-5.68-3.02-7.38c-2.01-1.69-4.9-2.55-8.65-2.55h-15.02v19.71Zm25.81,34.94c2.1-1.74,3.15-4.27,3.15-7.57s-1.1-5.9-3.29-7.78c-2.19-1.88-5.21-2.82-9.05-2.82h-16.63v20.79h16.9c3.84,0,6.81-.88,8.92-2.62Z"/>
                  <path class="pe_trivia_cls-3" d="m134.2,401.03c4.02-7.29,9.63-12.96,16.83-17.03,7.2-4.07,15.36-6.1,24.47-6.1,11.18,0,20.74,2.95,28.7,8.85,7.96,5.9,13.28,13.95,15.96,24.14h-25.22c-1.88-3.93-4.54-6.93-7.98-8.98-3.45-2.06-7.36-3.08-11.74-3.08-7.06,0-12.79,2.46-17.16,7.37-4.39,4.92-6.58,11.49-6.58,19.71s2.19,14.8,6.58,19.72c4.38,4.91,10.1,7.37,17.16,7.37,4.38,0,8.29-1.03,11.74-3.08,3.44-2.05,6.1-5.05,7.98-8.98h25.22c-2.68,10.19-8,18.22-15.96,24.07-7.96,5.86-17.52,8.78-28.7,8.78-9.12,0-17.28-2.03-24.47-6.1-7.2-4.07-12.81-9.72-16.83-16.97-4.02-7.24-6.03-15.51-6.03-24.81s2.01-17.59,6.03-24.87Z"/>
                  <path class="pe_trivia_cls-4" d="m425.83,490.9c-28.33-15.76-72.61-56.7-70.8-93.06,1.87-37.56,49.96-53.55,70.8-14.41,20.84-39.14,68.93-23.15,70.8,14.41,1.81,36.36-42.47,77.29-70.8,93.06Z"/>
                </svg>

              </div>
        <h1 class="pe_hdr-unauth">This website has not been authorised to use this puzzle</h1>
        <p class="pe_txt-unauth">If you are the website owner please contact <a class="pe_unauth-link" href="mailto:sales@puzzlexperts.com">sales@puzzlexperts.com</a></p>
      </div>
  </section>

</template>

<script lang="js">

  import { mapState, mapActions, mapGetters } from 'vuex'

  import Sudoku from '@puzzleapps/shared/src/components/ui/logos/Sudoku' 
  import Spinner from '@puzzleapps/shared/src/components/ui/Spinner' 
  import SlideoutMenu from '@puzzleapps/shared/src/components/ui/SlideoutMenu'
  import Heart from '@puzzleapps/shared/src/components/ui/logos/Heart' 
   import LovattsLogo from '@puzzleapps/shared/src/components/ui/logos/Lovatts'

  // import WebFont from 'webfontloader'

  export default  {
    name: 'splash-screen',
    props: [
      'logoComponent',
      'hasdifficulty'
    ],

    components: {
      Spinner,
      SlideoutMenu,
      Sudoku,
      Heart,
      LovattsLogo
    },

    created() {
      this.setFontLoaded = true
      
      // this.setArchiveFromApi(window.PE_CLIENTAPP_ID)
      //   .then(() => {
      //     this.todaysDate = this.setTodaysDate()
      //     this.archiveInit = true
      //   })
    },

    data() {
      return {
        showDifficultyModal: false,
        todaysDate: null,
        singleRouterPath: null,
        // archiveInit: false,
        setFontLoaded: false,
      }
    },

    methods: {
      ...mapActions({
        setGameMode: 'userSettings/setGameMode',
        // setArchiveFromApi: 'archive/setArchiveFromApi',
        clearPuzzleState: 'game/clearPuzzleState',
        setPuzzleId: 'game/setPuzzleId',
        goToPuzzleRoute: 'game/goToPuzzleRoute',
        resetPuzzle: 'game/resetTrivia',
        getTriviaHiScoreFromLocal : 'game/getTriviaHiScoreFromLocal',
      }),

      onPlayBtnClick(id) {
        this.resetPuzzle();
        this.getTriviaHiScoreFromLocal(id);


        this.goToPuzzleRoute({ router: this.$router, id })
      },

    },

    computed: {
      ...mapState({
        title: state => state.game.titleHtml,
        gameMode: state => state.userSettings.gameMode,
        appId: state => state.game.appId,
        gameType: state => state.game.type,        
        initialized: state => state.initialized,
        categories: state => state.game.categories,
        categoryID: state => state.game.puzzleID,
        unAuthorised: state => state.game.unauthorised,
      }),

    },

  }

</script>
<style>.pe_trivia_cls-1{fill:#5975d9;}.pe_trivia_cls-2{fill:#fff;}.pe_trivia_cls-3,.pe_trivia_cls-4{fill:#222;}.pe_trivia_cls-4{fill-rule:evenodd;}.pe_trivia_cls-5{fill:#dee3f7;}
svg#pe_svg_logo {
                background: #FFFFFF !important;
                border: 2px solid #fff !important;
                border-top: 1px solid #fff !important;
                border-left: 1px solid #fff !important;
                border-bottom: 1px solid #fff!important;
                border-right: 1px solid #fff!important;
                border-radius: 5px !important; 
            }
</style>
<style scoped lang="scss">
  @import '~@puzzleapps/shared/src/style/splashScreen';

  #puzzleapp.pe_puzzleapp.pe_trivia{
    background-color: #111d4a!important;
  }
  #puzzleapp.pe_trivia {
    
    .pe_splash-screen 
    {
      width: 100%;
        height: 100%;
        position: relative;
        //background-size: cover;
        z-index: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: center;
        //min-height: 500px;
    }
    .pe_splash-screen .pe_content {
      max-width: 820px;
      background-color: #111d4a;
      color: #fff;

      .pe_logo {
        font-size: 3em;
        color: #fff;
        border: 1px solid rgb(255, 255, 255);
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        //font-weight: 600;
        //background-image: linear-gradient(45deg, #c48eff, #93c3ff);
       // background-image: linear-gradient(135deg, #4b29ab, #7f55ff);
        margin-block: 0;
        margin-top: 0.18em;
        margin-right: 0.2em;
      }
      .pe_title{
        h1{
          color: #fff!important;
        }
        padding-top: 1em;
        padding-bottom: 1em;
      }
    }

    .pe_category-grid {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-gap: 0.5em;



      .pe_btn {
        margin: 0;
        font-size: 1em;
        // font-weight: 500;
        padding: 50% 0 0 0;
        line-height: 1.3;
        position: relative;
        color:#fff;
        background-color: #3759d2;

          &:hover{
            background-color: #7a90e1;
          }

        span {
          position: absolute!important;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 100%;
        }
      }
    }
    @media  (max-width: 640px) {
        .pe_category-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 1em;
        font-size: 0.8em;
      }
    }
  }
</style>
